import React from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip, Unstable_Grid2 } from "@mui/material";
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import DraggableDialog from "../CustomDialogs/DraggableDialog";
import ProductList from "./Components/ProductList";


const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}

export default function ProductListInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder, helperDetailText, placeholderDetail, inputDetailDisable, defaultValueName } = props

    const [state, setState] = React.useState({
        inputData: defaultValue,
        openDialog: false,
        titleDialog: "เลือกสินค้า",
        inputDetail: ""
    });

    React.useEffect(() => {

        setState((prevState) => ({
            ...prevState,
            inputData: defaultValue,
        }))

        return () => {
        }
    }, [defaultValue])
    React.useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            inputDetail: defaultValueName,
        }))

        return () => {
        }
    }, [defaultValueName])

    const handleChange = (event) => {
        // event.preventDefault(); 
        setState((prevState) => ({
            ...prevState,
            inputData: typeof event.target.value === "undefined" ? "" : event.target.value,
        }))
        try {
            props.resultData(typeof event.target.value === "undefined" ? "" : event.target.value)
        } catch (error) {
        }
    }
    const onBlur = (event) => {
        try {
            props.resultData(typeof event.target.value === "undefined" ? "" : event.target.value)
        } catch (error) {
        }
    }
    const handleKeyDown = (event) => {
        // event.preventDefault(); 
        try {
            //     if (event.key === "Enter") {
            props.keyDown(event.key)
        }
        catch (error) {
            console.log("handleKeyDown err", error);
        }
    }

    const handleSearchClick = () => {
        // console.log("testxxxxx handleSearchClick"); 

        setState((prevState) => ({
            ...prevState,
            openDialog: true,
        }))

    }

    const resultData = async (e) => {
        console.log("resultData", e);
        let code = ""
        let name = ""
        for (let index = 0; index < e.length; index++) {
            code += await e[index].code
            code += await index > -1 && index < e.length - 1 ? "," : "";
            name += await e[index].name
        }
        //await console.log(Sitecode);

        setState((prevState) => ({
            ...prevState,
            openDialog: false,
            inputData: code,
            inputDetail: name
        }))


        await props.resultData({ code: code, name: name })

    }
    return (
        <>
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '5px',
                    pt: '1px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",
                }}
            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "140px", whiteSpace: "nowrap",
                        fontSize: "16px",
                        fontFamily: "Customfont !important",
                        color: "black",
                        verticalAlign: "middle"
                    }}  >{label}</InputLabel>
                </Tooltip>


                <TextField
                    sx={{
                        //     "& label.Mui-focused": {
                        //         display: "none",
                        //     },
                        //     "& legend": {
                        //         display: "none",
                        //     },
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                        //     marginTop: "0px",
                    }}
                    hiddenLabel
                    id={id}
                    // defaultValue={defaultValue}
                    onChange={handleChange}
                    value={state.inputData}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                    inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont" } }}
                />

                <ManageSearchRoundedIcon sx={{ cursor: "pointer" }} onClick={_ => handleSearchClick()} />
                {inputDetailDisable === false ?

                    <TextField
                        sx={{

                            backgroundColor: "#fff",
                            fontFamily: "Customfont"

                        }}
                        hiddenLabel
                        id={id + "Detail"}
                        value={state.inputDetail}
                        helperText={helperDetailText}
                        variant="standard"
                        size="small"
                        type={inputType}
                        fullWidth
                        tabIndex={tabIndex + 1}
                        placeholder={placeholderDetail}

                        inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont", width: 500 } }}
                    />

                    : null}

            </Paper >
            <DraggableDialog open={state.openDialog} title={state.titleDialog} closeDialog={e => setState((prevState) => ({
                ...prevState,
                openDialog: false
            }))} >
                <ProductList resultData={e => resultData(e)} />
            </DraggableDialog>
        </>
    );
}
ProductListInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string,
    inputDetailDisable: PropTypes.bool,
    helperDetailText: PropTypes.string,
    placeholderDetail: PropTypes.string
}
ProductListInput.defaultValue = {
    inputDetailDisable: true
}